"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:6.5.3'] && _();
}
catch (e) { }
